import showdown from "showdown"

const converter = new showdown.Converter()
export default converter
